<template>
  <v-dialog v-model="show" persistent max-width="480">
    <v-card light>
      <v-card-text style="padding-bottom:0px;">
        <v-carousel cycle height="460" hide-delimiter-background light show-arrows-on-hover>
          <v-carousel-item v-for="(slide, i) in slides" :key="i">
            <v-sheet height="100%" color="white">
              <v-row class="mt-5" align="center" justify="center">
                <div
                  class="px-3 rundown-dialog-head"
                  style="color:#0099CC;  text-align: center; font-size:1.8em"
                >{{ slide.title }}</div>
              </v-row>

              <v-row align="center" justify="center">
                <v-img class="mt-5" contain min-height="200" max-height="200" :src="slide.image" />
              </v-row>

              <v-row align="center" justify="center">
                <div
                  class="mt-5 px-3"
                  style="color:#111; text-align: center; font-size:1.2em"
                >{{ slide.message }}</div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-card-text>
      <v-card-actions style="padding-top:0px;">
        <v-spacer></v-spacer>
        <v-btn color="primaryBlue" class="rundown-dialog-btn" text @click="closePopup()">{{$t('WELCOME_CLOSE_POPUP')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>  
export default {
  name: "WelcomeDialog",
  props: [],
  data() {
    return {
      show: false,
      slides: [], 
    };
  },
  methods: {
    handleWelcome(shownCallback) {
      if (!window.rundownApp || !window.rundownApp.localStorage) {
        setTimeout(this.handleWelcome, 2000);
        return;
      }

      const item = "welcome-rundown-shown-" + this.$t("WELCOME_VERSION");

      window.rundownApp.localStorage.getItem(item, (value) => {
        if (value) {
          if (shownCallback)
             shownCallback(false);
          return;
        }

        this.show = true;
        this.slides = this.$t("WELCOME_SLIDES");

        window.rundownApp.localStorage.setItem(item, true);

        if (shownCallback)
             shownCallback(true);

        window.rundownApp.device.backButtonCallback = this.closePopup;
      });
    },
    closePopup() {
      this.show = false;
      window.rundownApp.device.backButtonCallback = null;
    },
  },
};
</script>